import { LOAD_TERMS, LOAD_ERROR } from './types'

// Libs
import Api from '@/core/api'

export const load = ({ commit }) => {
  return new Promise((resolve, reject) => {
    let filters = "/search/filters"
    Api().get(filters)
      .then (response => {
        const data = response.data
        commit(LOAD_TERMS, { data })
        resolve(response)
      })
      .catch (error => {
        commit(LOAD_ERROR, {
          name: error.name,
          message: error.message,
        })
        reject(error)
      })
  })
}

// export const setFilters = ({ commit }, payload) => {
//   console.log(payload)
//   commit(SET_FILTERS, payload)
// }

export const setError = ({ commit }, error) => {
  commit(LOAD_ERROR, {
    name: error.name,
    message: error.message,
  })
}
